<template>
  <div id="location-form-input" ref="locationForm">
    <div class="select m-1">
      <select
        name="department"
        v-model="selected.department"
        @change="onSelectedDept"
      >
        <option value="">vacio</option>
        <option
          v-for="(dept, i) in ubigeoLists.departments"
          :key="'dept' + i"
          :value="dept"
        >
          {{ dept }}
        </option>
      </select>
    </div>

    <div class="select m-1">
      <select
        name="province"
        v-model="selected.province"
        @change="onSelectedProvince"
      >
        <option value="">vacio</option>
        <option
          v-for="(prov, i) in ubigeoLists.provinces"
          :key="'prov' + i"
          :value="prov"
        >
          {{ prov }}
        </option>
      </select>
    </div>

    <div class="select m-1">
      <select
        name="district"
        v-model="selected.district"
        @change="onSelectedDistrict"
      >
        <option value="">vacio</option>
        <option
          v-for="(dist, i) in ubigeoLists.districts"
          :key="'dist' + i"
          :value="dist"
        >
          {{ dist }}
        </option>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, 
  // onMounted,
  reactive,
  ref,
  toRefs,
  //inject,
} from "vue";


interface LocationList {
  districts: string[];
  provinces: string[];
  departments: string[];
}
interface UbigeoItemData {
  district: string;
  province: string;
  department: string;
}

export default defineComponent({
  name: "locationFormInput",
  props: {
    modelValue: {
      type: Object,
      default: (): UbigeoItemData => ({
        district: "",
        province: "",
        department: "",
      }),
    },
  },
  async setup(props, { emit }: any) {
    const ubigeoLists = reactive<LocationList>({
      districts: [],
      provinces: [],
      departments: [],
    });

    const selected = reactive<UbigeoItemData>({
      department: "",
      province: "",
      district: "",
    });

    const locationForm = ref<HTMLElement | null>(null);
    
		let ubigeoData: UbigeoItemData[] = await require("../assets/ubigeo.json");

    const onlyUnique = (item: string, index: number, self: string[]) => {
      return self.indexOf(item) === index;
    };

    ubigeoLists.departments = ubigeoData
      .map((ud: UbigeoItemData) => ud.department)
      .filter(onlyUnique);
		if (ubigeoLists.departments.length == 1 &&
      props.modelValue.department === ""
    ) {
      selected.department = ubigeoLists.departments[0];
    }

    ubigeoLists.provinces = ubigeoData
      .map((ud: UbigeoItemData) => ud.province)
      .filter(onlyUnique);
    if (ubigeoLists.provinces.length == 1 && props.modelValue.province === "") {
      selected.province = ubigeoLists.provinces[0];
    }

    ubigeoLists.districts = ubigeoData
      .map((ud: UbigeoItemData) => ud.district)
      .filter(onlyUnique);

    if (ubigeoLists.districts.length == 1 && props.modelValue.district === "") {
      selected.district = ubigeoLists.districts[0];
    }

    function onSelectedDept() {
      ubigeoLists.provinces = ubigeoData
        .filter((ud: any) => ud.department === selected.department)
        .map((ud: any) => ud.province)
        .filter(onlyUnique);
      emit("update:modelValue", { ...selected });
    }

    function onSelectedProvince() {
      ubigeoLists.districts = ubigeoData
        .filter((ud: any) => ud.province === selected.province)
        .map((ud: any) => ud.district)
        .filter(onlyUnique);
      emit("update:modelValue", { ...selected });
    }

    function onSelectedDistrict() {
      emit("update:modelValue", { ...selected });
    }

    let { modelValue } = toRefs(props);
    if ((props.modelValue as UbigeoItemData).department !== "") {
      selected.department = modelValue.value.department;
    }
    if ((props.modelValue as UbigeoItemData).province !== "") {
      selected.province = modelValue.value.province;
    }
    if ((props.modelValue as UbigeoItemData).district !== "") {
      selected.district = modelValue.value.district;
    }

    return {
      ubigeoLists,
      onSelectedDept,
      onSelectedProvince,
      onSelectedDistrict,
      selected,
      locationForm,
    };
  },
});
</script>
